import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { of, Observable } from 'rxjs';
import {
  filter,
  map,
  switchMap,
  take,
  timeout,
  catchError,
} from 'rxjs/operators';
import { SessionQuery } from '../state-mangement/session/session.query';
import { SideMenuQuery } from '../state-mangement/side-menu/side-menu.query';
import { firstNavigable } from '../state-mangement/side-menu/menu.utils';

@Injectable({ providedIn: 'root' })
export class AlreadyAuthGuard implements CanActivate {
  constructor(
    private sessionQuery: SessionQuery,
    private sideMenuQuery: SideMenuQuery,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.sessionQuery.successful$.pipe(
      take(1),
      switchMap((loggedIn) => {
        if (!loggedIn) return of(true);

        return this.sideMenuQuery.tree$.pipe(
          map((tree) => firstNavigable(tree || [])),
          filter((n) => !!n && !!n.route),
          take(1),
          map((n) => this.router.createUrlTree([n!.route!])),
          timeout({
            first: 10000,
            with: () => {
              console.warn(
                'AlreadyAuthGuard timed out waiting for menu. Allowing navigation to proceed.'
              );
              return of(true);
            },
          }),
          catchError((err) => {
            console.error('Error in AlreadyAuthGuard', err);
            return of(true);
          })
        );
      })
    );
  }
}
